// api.js

import axios from 'axios';
import data from '../UserSettings.json';

const api = axios.create({
  baseURL: data.apiUrl,
});

export default api;